import { NgModule } from '@angular/core';
import { ApprovalsComponent } from './approvals.component';

@NgModule({
  declarations: [ApprovalsComponent],
  exports: [ApprovalsComponent],
})
export class ApprovalsModule {}
